import type { CreateTeamDTO } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { teamsKeys } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client";

export function useCreateTeam(): UseMutationResult<void, Error, CreateTeamDTO> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateTeamDTO) =>
      apiClient.url("/teams").post(data).res(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: teamsKeys.all,
      });
    },
  });
}
